// Google Analytics Event Tracking
// Docs: https://developers.google.com/analytics/devguides/collection/gtagjs/events
StepStone.trackEvent = function (action, category, label, value, callback) {

  if ( typeof gtag == 'function' ) {

    var event_action    = action || null,
        event_category  = category || null,
        event_label     = label || null,
        event_value     = value || null,
        event_callback  = callback || function(){};

    if (event_action === null) { return; } // action is required

    // Send GA Event
    gtag('event', event_action, {
      'event_category': event_category,
      'event_label':    event_label,
      'value':          event_value,
      'event_callback': event_callback
    });

  } // end if gtag

}; // trackEvent